import TscPopoverOrigin from '../constants/TscPopoverOrigin';
export var getMenuData = function getMenuData(origin, showArrow) {
  var menuDistance = showArrow ? 'calc(100% + 20px)' : 'calc(100% + 10px)';

  if (origin === TscPopoverOrigin.top) {
    return {
      bottom: menuDistance,
      left: '50%',
      transform: 'translateX(-50%)',
      transformOrigin: 'center bottom'
    };
  } else if (origin === TscPopoverOrigin.bottom) {
    return {
      top: menuDistance,
      left: '50%',
      transform: 'translateX(-50%)',
      transformOrigin: 'center top'
    };
  } else if (origin === TscPopoverOrigin.left) {
    return {
      right: menuDistance,
      top: '50%',
      transform: 'translateY(-50%)',
      transformOrigin: 'right center'
    };
  } else if (origin === TscPopoverOrigin.right) {
    return {
      left: menuDistance,
      top: '50%',
      transform: 'translateY(-50%)',
      transformOrigin: 'left center'
    };
  } else if (origin === TscPopoverOrigin.topLeft) {
    return {
      bottom: menuDistance,
      left: '0',
      transformOrigin: 'bottom left'
    };
  } else if (origin === TscPopoverOrigin.topRight) {
    return {
      bottom: menuDistance,
      right: '0',
      transformOrigin: 'bottom right'
    };
  } else if (origin === TscPopoverOrigin.bottomLeft) {
    return {
      top: menuDistance,
      left: '0',
      transformOrigin: 'top left'
    };
  } else if (origin === TscPopoverOrigin.bottomRight) {
    return {
      top: menuDistance,
      right: '0',
      transformOrigin: 'top right'
    };
  }

  return {};
};
export var getArrowData = function getArrowData(origin) {
  if (origin === TscPopoverOrigin.top) {
    return {
      bottom: '-12px',
      left: '50%',
      transform: 'translateX(-50%) rotate(180deg)'
    };
  } else if (origin === TscPopoverOrigin.bottom) {
    return {
      top: '-12px',
      left: '50%',
      transform: 'translateX(-50%)'
    };
  } else if (origin === TscPopoverOrigin.left) {
    return {
      right: '-16px',
      top: '50%',
      transform: 'translateY(-50%) rotate(90deg);'
    };
  } else if (origin === TscPopoverOrigin.right) {
    return {
      left: '-16px',
      top: '50%',
      transform: 'translateY(-50%) rotate(-90deg);'
    };
  } else if (origin === TscPopoverOrigin.topLeft) {
    return {
      bottom: '-12px',
      left: '10px',
      transform: 'rotate(180deg)'
    };
  } else if (origin === TscPopoverOrigin.topRight) {
    return {
      bottom: '-12px',
      right: '10px',
      transform: 'rotate(180deg)'
    };
  } else if (origin === TscPopoverOrigin.bottomLeft) {
    return {
      top: '-12px',
      left: '10px'
    };
  } else if (origin === TscPopoverOrigin.bottomRight) {
    return {
      top: '-12px',
      right: '10px'
    };
  }

  return {};
};